import { useCallback, useMemo } from 'react';
import { MailActions, useActions, useAppSelector } from '@web-common/state/createStore';
import { createSelector } from '@reduxjs/toolkit';
import lodash from 'lodash';
import { isMailListDiff } from '@web-mail/utils/mailCompare';
const UPDATE_MAIL_ID_REDUCER = 'doUpdateMailId';
const useMailStore = (stateName, config, sliceId, type) => {
    const selectMailIds = useCallback((state) => {
        if (sliceId) {
            if (state.mailReducer[type][sliceId]) {
                return state.mailReducer[type][sliceId][stateName];
            }
            throw new Error('slice not exist');
        }
        return state.mailReducer[stateName];
    }, [stateName, type, sliceId]);
    const excludeKeyMap = useCallback((state) => state.mailReducer.mailExcludeKeyMap, []);
    const mailStore = useCallback((state) => state.mailReducer.mailEntities, []);
    const updateIdReducer = useActions(MailActions)[UPDATE_MAIL_ID_REDUCER];
    const updateMailStoreReducer = useActions(MailActions).updateMailEntities;
    const mailSelector = useMemo(() => createSelector([selectMailIds, mailStore, excludeKeyMap], (ids, store, excludeMap) => {
        var _a;
        const mailList = ids ? (_a = ids.map(id => store[id])) === null || _a === void 0 ? void 0 : _a.filter(item => item) : [];
        if (config && config.key && config.exclude && config.exclude.length) {
            return mailList.map(mail => {
                const res = mail
                    ? Object.assign(Object.assign({}, mail), { entry: Object.assign({}, mail.entry) }) : {};
                config.exclude.forEach(path => {
                    lodash.set(res, path, lodash.get(excludeMap, [config.key, mail.entry.id].join('.') + path));
                });
                return res;
            });
        }
        else {
            return mailList;
        }
    }), [selectMailIds]);
    const selectMailList = useAppSelector(mailSelector, (prev, next) => !isMailListDiff(prev, next));
    const setter = (mailList) => {
        let list = [];
        if (typeof mailList === 'function') {
            list = mailList(selectMailList);
        }
        else {
            list = mailList;
        }
        if (Array.isArray(list)) {
            updateIdReducer({
                stateName,
                mailList: list,
                sliceId,
                type,
            });
        }
        else {
            updateMailStoreReducer({
                mailList: [list],
            });
            updateIdReducer({
                stateName,
                mailList: [list],
                sliceId,
                type,
            });
        }
    };
    return [selectMailList, setter];
};
export default useMailStore;
